<script setup lang="ts">
import type AssetBooking from '@/classes/assetBooking';
import { MutationTypes } from '@/store/store_types';
import getAssetSrc from '@/utils/getAssetSrc';
import { useStore } from 'vuex';

const { booking, completed = false } = defineProps<{ booking: AssetBooking, completed?: boolean }>()
const defaultVehicleImage = getAssetSrc('car_images/placeholder_car.png')
const store = useStore()
const displayBookingData = () => {
  store.commit(MutationTypes.setDisplayedBookingId, booking.local_id)
  store.commit(MutationTypes.setDashboardDialogContent, completed ? 'completed-booking-details' : 'upcoming-booking-details')
  store.commit(MutationTypes.setShowDashboard, true)
}


</script>
<template>
  <v-card
    class="d-flex align-center flex-nowrap justify-space-between pa-3 mb-3"
    flat
    color="pwt_alabaster"
    rounded="lg"
    @click="displayBookingData"
  >
    <v-col cols="10" class="pa-0">
      <v-card-title class="py-0 pl-0"> {{ booking.formattedStartDate }} </v-card-title>
      <v-card-subtitle class="pl-0">
        {{ booking.formattedStartTime }} - {{ booking.formattedEndTime }}
      </v-card-subtitle>
      <v-card-text class="pl-0 pb-0"> {{ booking.description }} </v-card-text>
    </v-col>
    <v-col md="2" class="pa-0">
      <!-- image section -->
      <v-img
        v-if="booking.displayImgSrc"
        contain
        :src="booking.displayImgSrc"
        :lazy-src="booking.asset_type === 'vehicle' ? defaultVehicleImage : undefined"
        aspect-ratio="1"
        width="100%"
        height="auto"
        style="margin: auto"
      ></v-img>
    </v-col>
  </v-card>
</template>
